import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./about.scss";
// Components
import Title from "../ui-components/title/title";
// Assets
import Person01 from "../../assets/about/person01.png";
import Person02 from "../../assets/about/person02.png";

const About = ({ language }) => {
  const translations = {
    en: {
      title: "ABOUT US",
      description:
        "At Kafa'ah, we are passionate about providing flexible and customizable service where every customer's needs are fulfilled. We ensure that every contract is maintained at a high level of quality by doing one-off spot checks and scheduled visits. Our processes are well-tested, and the methods are delivered by our skilled personnel.",
    },
    ar: {
      title: "معلومات عنا",
      description:
        "في كفاءة، نحن شغوفون بتقديم خدمات مرنة وقابلة للتخصيص لتلبية احتياجات كل عميل. نضمن أن يتم الحفاظ على كل عقد بمستوى عالٍ من الجودة من خلال عمليات التفتيش الفوري المجدولة. تم اختبار عملياتنا جيدًا وتُنفذ بواسطة موظفينا المهرة.",
    },
  };

  const isArabic = language === "ar";

  return (
    <div id="about">
      <div className="wrapper">
        <Title title={translations[language].title} />
        <center>
          <p className={`font14 ${isArabic ? "rtl-text" : ""}`}>
            {translations[language].description}
          </p>
        </center>
        {/* Team section can be uncommented and localized if needed */}
        {/* <Row>
          <Col md={12} lg={4}>
            <TeamBox avatar={Person01} name="Luke Skywalker" job="Web Designer" />
          </Col>
          <Col md={12} lg={4}>
            <TeamBox avatar={Person02} name="Han Solo" job="Graphic Designer" />
          </Col>
          <Col md={12} lg={4}>
            <TeamInfo />
          </Col>
        </Row> */}
      </div>
    </div>
  );
};

export default About;
